module.exports = __webpack_public_path__ + "img/m1.49e180f0.png";